// Helper function to match certification service names
export const matchCertificationService = (value, services) => {
  if (!value) return null;
  
  const normalizedValue = value.toLowerCase().trim();
  
  // First try exact match
  let service = services.find(s => s.name.toLowerCase() === normalizedValue);
  if (service) return service;

  // Then try common variations
  const commonNames = {
    'pcgs': ['pcgs', 'professional coin grading service'],
    'ngc': ['ngc', 'numismatic guaranty corporation', 'numismatic guaranty company'],
    'anacs': ['anacs', 'american numismatic association certification service']
  };

  for (const [serviceName, variations] of Object.entries(commonNames)) {
    if (variations.includes(normalizedValue)) {
      service = services.find(s => s.name.toLowerCase() === serviceName);
      if (service) return service;
    }
  }

  // Try partial matches
  service = services.find(s => normalizedValue.includes(s.name.toLowerCase()));
  return service || null;
};

// Helper function to get service name from ID
export const getServiceName = (id, services) => {
  const service = services.find(s => s.id === parseInt(id));
  return service ? service.name : '';
};
